<template>
  <TableGradient
      icon-name="bolt"
      :title="$t('states.listagem.titulo_pagina')"
      :text-empty="$t('states.listagem.table.empty')"
      route-new="vns.states.create"
      :text-new="$t('states.listagem.novo')"
      :fields="fields"
      :fields-filter="filter"
      :items="states"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('states/listAll', evt)"
      table-data>
    <template v-slot:cell(id)="linha">
      <router-link :id="`link-edit-${linha.index}`" :to="{ name: 'vns.states.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('states.listagem.table.editar') }}
      </router-link>
    </template>
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.status, 'badge badge-danger': !linha.item.status}">
          <i :class="linha.item.status ? 'fas fa-check' : 'fas fa-ban'"/>
      </span>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      states: 'states/all',
      paginator: 'states/pagination',
      store_isLoading: 'states/isLoading',
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('states.listagem.table.nome'), sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('states.listagem.table.editar')}
      ],
      filter: [
        {key: 'name', label: this.$t('states.listagem.filtro.nome')}
      ]
    }
  },
  methods: {
    ...mapActions([
      'states/listAll'
    ])
  },
  mounted() {
    this['states/listAll'](this.paginator)
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
